export const validationClass = (field: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $errors: any[];
    $dirty: boolean;
}): string => {
    if (field.$errors.length) {
        return "error";
    }
    if (!field.$errors.length && field.$dirty) {
        return "valid";
    }
    return "";
};

export const smokerValidationClass = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    field: { $errors: any[]; $dirty: boolean },
    addIfClean: boolean
): string => {
    if (field.$errors.length) {
        return "error";
    }
    if (addIfClean && !field.$errors.length && field.$dirty) {
        return "valid";
    }
    return "";
};

export const checkLeapYear = (year: number) => {
    return new Date(year, 1, 29).getDate() === 29;
};

export const validDays = (day: number, month: number, year: number) => {
    const thirtyDayMonths = [4, 6, 9, 11];
    if (month === 2 && day === 29 && !checkLeapYear(year)) {
        return false;
    }
    if (month === 2 && day > 29) {
        return false;
    }
    if (thirtyDayMonths.includes(month) && day > 30) {
        return false;
    }
    return true;
};
